import React, { FC, MutableRefObject, ReactNode } from 'react'

import { NativeModal, NativeModalActions, NativeModalBody, NativeModalHeader } from '@Components/Modal/NativeModal/NativeModal'

import styles from './ProductSidePaneLayout.module.scss'

type ProductSidePaneLayoutProps = {
  actionRef?: MutableRefObject<NativeModalActions | null>
  children?: React.ReactNode
  footer?: ReactNode
  onOpen?: () => void
  prerender?: boolean
  title?: ReactNode
}

export const ProductSidePaneLayout: FC<ProductSidePaneLayoutProps> = ({
  actionRef,
  children,
  footer,
  onOpen,
  prerender,
  title,
}) => (
  <NativeModal
    actionRef={actionRef}
    alignment="right"
    backdrop
    className={styles.modal}
    onOpen={onOpen}
    prerender={prerender}
  >
    <NativeModalHeader>
      {title}
    </NativeModalHeader>
    <NativeModalBody>
      {children}

      {footer && <div className={styles.footer}>{footer}</div>}
    </NativeModalBody>
  </NativeModal>
)
